import { useState } from 'react';
import CreateSalesReturnHeader from './createSalesReturnHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import SalesReturnForm from './salesReturnForm';

const CreateSalesReturn = () => {
	const [error, setError] = useState({});
	const [tableError, setTableError] = useState([]);
	const [productTable, setProductTable] = useState([]);
	const [additionDiscountAndTax, setAdditionDiscountAndTax] = useState({
		discount: '',
		adj: '',
		round_off: '',
	});
	const [salesReturn, setSalesReturn] = useState({
		customer_id: null,
		sales_return_number: '',
		reference: '',
		date: getCurrentDate(),
		payment_method: '',
		notes: '',
	});

	function totalDiscountAmount() {
		let amount = productTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
		let totalDiscount = (amount * additionDiscountAndTax.discount) / 100;
		return totalDiscount;
	}
	function totalTaxesAmount() {
		let totalTax1 = productTable?.reduce(
			(sum, item) =>
				Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax1 ?? 0)) / 100,
			0,
		);
		let totalTax2 = productTable?.reduce(
			(sum, item) =>
				Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax2 ?? 0)) / 100,
			0,
		);
		return Number(totalTax1) + Number(totalTax2);
	}
	function totalAmount() {
		let amount = productTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
		let totalTaxes = totalTaxesAmount();

		let totalAmountWithDiscount = amount - (amount * additionDiscountAndTax.discount) / 100;
		let totalAmountWithTax = Number(totalAmountWithDiscount) + Number(totalTaxes);
		return (
			Number(totalAmountWithTax) -
			Number(additionDiscountAndTax.adj ?? 0) -
			Number(additionDiscountAndTax.round_off ?? 0)
		);
	}
	const calculateAmount = () => {
		return productTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
	};
	return (
		<div>
			<CreateSalesReturnHeader
				salesReturn={salesReturn}
				productTable={productTable}
				error={error}
				setError={setError}
				tableError={tableError}
				setTableError={setTableError}
				totalDiscountAmount={totalDiscountAmount}
				totalTaxesAmount={totalTaxesAmount}
				totalAmount={totalAmount}
				calculateAmount={calculateAmount}
				additionDiscountAndTax={additionDiscountAndTax}
			/>
			<SalesReturnForm
				error={error}
				setError={setError}
				tableError={tableError}
				productTable={productTable}
				setTableError={setTableError}
				salesReturn={salesReturn}
				setSalesReturn={setSalesReturn}
				setProductTable={setProductTable}
				setAdditionDiscountAndTax={setAdditionDiscountAndTax}
				additionDiscountAndTax={additionDiscountAndTax}
				totalDiscountAmount={totalDiscountAmount}
				totalTaxesAmount={totalTaxesAmount}
				totalAmount={totalAmount}
				calculateAmount={calculateAmount}
			/>
		</div>
	);
};
export default CreateSalesReturn;
